<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">

    <img class="page-logo" src="@/assets/home/2.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>扑克占卜</span>
    </div>
    <div class="text">
      <p>
        占卜方法∶洗牌的工作我们已经为您做好了，现在请您闭上眼睛、深呼吸、身心神合一地冥想自己中奖的情况，然后张开眼睛再深呼吸一口气，从上面已经洗好的扑克牌中，按照直觉随便选一张牌就可以了。
      </p>
      <p>注意:每天只可以算一次，多算可是不灵的哦!快来看看您的发财大运!。</p>
    </div>

    <div class="select-pk-box">
      <div class="pk-box">
        <div class="pk" @click="start">
          <img src="../../../../assets/pk/p_l.png" alt="" />
        </div>
        <div class="pk" @click="start">
          <img src="../../../../assets/pk/p_r.png" alt="" />
        </div>
      </div>
      <!-- <div class="pk-ps">点击选择</div> -->
    </div>

    <div style="height: 3rem"></div>

    <div class="start-btn" @click="start">开始测算</div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
    </div>

  </div>
</template>

<script>
/**
@description:扑克占卜
@createTime:2021-08-25
@create:wq
*/
import topTab from "@/components/topTab";

import shareBottomComp from "@/components/shareBottomComp";
import { shareJsSdk, HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { shareBottomComp ,topTab},
  data() {
    return {
      share: 0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'扑克占卜',
        path:'/pk'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
    shareJsSdk("pk", "扑克占卜",'','',HERF+'/image/2.png');
  },
  methods: {
    start() {
      this.api.poker().then((res) => {
        localStorage.setItem("result", JSON.stringify(res.data));
        this.$router.push("pkres");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}

.select-pk-box {
  margin-top: 0.7rem;
  height: 4rem;
  background: #f0f0f0;
  overflow: hidden;
  .pk-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.7rem;
    .pk {
      margin: 0 0.31rem;
      width: 1.74rem;
      height: 2.46rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pk-ps {
    font-size: 0.24rem;
    font-weight: 400;
    color: #53cedc;
    text-align: center;
    margin-top: 0.38rem;
  }
}
.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>
